// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lm-0";
export var buttonContainer = "_lm-3";
export var cancelButton = "_lm-4";
export var headerSection = "_lm-6";
export var headerTitle = "_lm-9";
export var messageSideLeft = "_lm-1";
export var messageSideRight = "_lm-2";
export var orderNumberContainer = "_lm-7";
export var orderNumberLabel = "_lm-8";
export var submitButton = "_lm-5";